import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { timeline } from "@/mocks/gossip";

const statusStyle: Record<string, string> = {
  持续中: "bg-primary-100 text-primary-800",
  真伪存疑: "bg-accent-100 text-accent-900",
  技术分析: "bg-secondary-100 text-secondary-900",
};

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full bg-secondary-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          index="02"
          title="传闻时间线"
          subtitle="把零散的说法按日期钉在一根轴上。哪些是早期苗头，哪些是二次传播，一眼就能看出脉络。"
          meta="共 5 个关键节点"
        />

        <div className="relative mt-10 md:mt-14">
          <span className="absolute left-[10px] top-2 hidden h-[calc(100%-16px)] w-px bg-background-300 md:block" />
          <div className="flex flex-col gap-4 md:gap-6">
            {timeline.map((node, idx) => (
              <Reveal key={node.date} delay={idx * 70}>
                <div className="relative md:pl-12">
                  <span className="absolute left-0 top-6 hidden h-[21px] w-[21px] items-center justify-center rounded-full border-2 border-secondary-50 bg-accent-500 md:flex">
                    <span className="h-1.5 w-1.5 rounded-full bg-secondary-50" />
                  </span>
                  <article className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300 md:p-6">
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="font-display text-lg font-black tracking-wide text-accent-600 md:text-xl">
                        {node.date}
                      </span>
                      <span
                        className={`rounded-md px-2 py-0.5 text-[11px] font-semibold ${
                          statusStyle[node.status] ?? "bg-background-100 text-foreground-700"
                        }`}
                      >
                        {node.status}
                      </span>
                      <span className="text-[11px] text-foreground-500">来源：{node.source}</span>
                    </div>
                    <h3 className="mt-3 font-heading text-base font-bold text-foreground-950 md:text-lg">
                      {node.title}
                    </h3>
                    <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                      {node.desc}
                    </p>
                  </article>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <p className="mt-8 flex items-start gap-2 rounded-lg border border-background-200 bg-background-50/70 p-4 text-xs leading-relaxed text-foreground-500 md:text-sm">
          <i className="ri-information-line mt-0.5 text-base text-secondary-500" />
          时间线仅整理网络公开讨论的出现顺序，不代表对任何说法真实性的认定。
        </p>
      </div>
    </section>
  );
}